<template>
  <component
    :is="tag"
    class="headline"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'CHeadline',

  props: {
    level: {
      type: [Number, String],
      default: 1
    }
  },

  computed: {
    tag () {
      return `h${this.level}`
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.headline {
  font-size: 1.25em;
  text-transform: uppercase;

  small {
    display: block;
    font-weight: 400;
  }

  @media (min-width: $breakpoint-md) {
    font-size: 1.5em;
  }
}

.headline__badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 1.6em;
  min-width: 1.6em;
  margin-right: 0.5em;
  padding: 0 0.5em;
  vertical-align: 0.2em;

  font-size: 0.625em;
  color: #fff;

  background-color: $color-secondary-dark;
  border-radius: 1em;
}
</style>
